import * as React from "react";
import "./styles.scss";
import { navigate } from "gatsby-plugin-intl";

export default function ClaimRewardBtn({ text, to }) {
    return (
        <div className="button-container">
            <button
                type="button"
                className="btn btn-rewards"
                onClick={() => {
                    navigate(to);
                    localStorage.setItem("selecteddisplay", "passport");
                }}
            >
                <span>
                    {text ? text : "Claim my gift"}
                </span>
            </button>
        </div>
    )
}
